module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Hinzufügen","cancel":"Abbrechen","selectSites":"Märkte wählen"},"en":{"add":"Add","cancel":"Cancel","selectSites":"Select sites"}}')
  delete Component.options._Ctor
}
